import { produce, original, Draft } from 'immer'

import { BankCard } from '../common/types/bank'
import API, { ResponseManagement } from '../API';
import Utility from '../Utility';
import { toast } from 'react-toastify';
import {ID} from "../common/types";

type Payload = {
  bookingFolderId: ID,
  active: boolean,
  virtualCard: boolean
}

type PayloadAddCard = {
  establishmentId: ID,
  organizationId: ID,
  bookingFolderId: ID,
  userId?: ID,
  action: string,
  email: string
}

type PayloadUpdateCard = {
  id: ID,
  bankCard: BankCard,
  bookingFolderId: ID,
  prestay: boolean,
  stay: boolean
}

type Partial<T> = {
  [key in keyof T]?: T[key]
}

type State = {
  isActivated: boolean,
  bookingFolderId: ID,
  lastCardId: ID,
  isFirstCard: boolean,
  cards: BankCard[]
}

const bank = {
  state: {
    isActivated: false,
    bookingFolderId: "",
    lastCardId: "",
    isFirstCard: false,
    cards: []
  } as State,
  reducers: {
    loaded: produce((draft: Draft<State>, bankCards: BankCard[]) => {
      // order bankCards
      let tempBankCards = [];

      if (bankCards.length > 0) {
        if (bankCards.length === 1) {
          tempBankCards = bankCards;
        } else {
          let indexPrestay = bankCards.findIndex(bankCard => {
            return bankCard.prestay === true;
          })
          let indexStay = bankCards.findIndex(bankCard => {
            return bankCard.stay === true;
          })
          let tabBankCardWithoutUsing = bankCards.filter(bankCard => {
            return !bankCard.prestay && !bankCard.stay
          })

          if (indexPrestay !== -1) {
            tempBankCards[0] = bankCards[indexPrestay]
            if (indexPrestay !== indexStay) tempBankCards[1] = bankCards[indexStay]
          } else {
            tempBankCards[0] = bankCards[indexStay]
          }
          if (tabBankCardWithoutUsing.length > 0) Array.prototype.push.apply(tempBankCards, tabBankCardWithoutUsing);
        }
      }

      draft.cards = tempBankCards;
    }),
    setStateProperties: produce((draft: Draft<State>, payload: Partial<State>) => {
      Object.assign(draft, payload)
    }),
    checkIsActivated: produce((draft: Draft<State>, bankModuleId: number) => {
      draft.isActivated = bankModuleId > 2 && true;
    }),
    addCard: produce((draft: Draft<State>, bankCard: BankCard) => {
      const cards = original(draft.cards);

      if(cards.length === 0) {
        draft.isFirstCard = true
      } else {
        draft.isFirstCard = false;
      }

      draft.cards = [bankCard, ...cards]
      draft.lastCardId = bankCard.id;
    }),
    updateCard: produce((draft: Draft<State>, id: string, prestay: boolean, stay: boolean) => {
      const indexCardToUpdate = draft.cards.findIndex(card => {
        return card.id == id;
      });
      draft.cards[indexCardToUpdate].prestay = prestay;
      draft.cards[indexCardToUpdate].stay = stay;
    }),
    removeCard: produce((draft: Draft<State>, id: string) => {
      draft.cards = draft.cards.filter(card => card.id != id)
    })
  },
  // async methods
  effects: dispatch => ({
    async load(payload: Payload, rootState) {
      const request = new URLSearchParams({
        ...payload
      } as any);
      const response = await API.post(Utility.getUrlAjax() + `/bankCardsList`, request)

      ResponseManagement(response, () => {
        dispatch.bank.setStateProperties({bookingFolderId: payload.bookingFolderId});
        dispatch.bank.loaded(JSON.parse(response.data.data));
      },() => {
        toast.error('Data loading error');
      })
    },
    async checkIsActivatedAsync(payload: {establishmentId: number}, rootstate) {
      const dataToSend = new URLSearchParams({
        ...payload
      } as any);
      const response = await API.post(Utility.getUrlAjax() + `/bankModuleInfos`, dataToSend)

      ResponseManagement(response, () => {
        dispatch.bank.checkIsActivated(parseInt(response.data.data.bankModuleId));
      },() => {
        toast.error('Data loading error');
      })
    },
    async addCardAsync(payload: PayloadAddCard) {
      let dataToSend = new URLSearchParams({
        ...payload
      } as any);

      const response = await API.post(Utility.getUrlAjax() + `/bankCardsList`, dataToSend)

       ResponseManagement(response, () => {
        dispatch.bank.addCard(JSON.parse(response.data.data).reverse());
      },() => {
        toast.error('Data loading error');
      })
    },
    async updateCardAsync(payload: PayloadUpdateCard, rootState) {
      let dataToSend = JSON.stringify({
        ...payload
      }) as any;
      const response = await API.post(Utility.getUrlAjax() + `/updateBankCard`, dataToSend)

      ResponseManagement(response, async () => {
        if (response.data.success === true) {
          await dispatch.bank.load({bookingFolderId: rootState.bank.bookingFolderId, active: "1", virtualCard: false});
        }
      },() => {
        toast.error('Data loading error');
      })
    },
    async removeCardAsync(payload: {data: {bookingFolderId: number, id: number}, tradDisableSuccess: {tradRemoveBankCardSuccess: string}},  rootState) {
      let dataToSend = new URLSearchParams({
          ...payload.data
      } as any);
      const response = await API.post(Utility.getUrlAjax() + `/disableBankCard`, dataToSend)

      ResponseManagement(response,
        () => {
          if (response.data.success === true) {
            dispatch.bank.removeCard(payload.data.id)
            toast.success(payload.tradDisableSuccess?.tradRemoveBankCardSuccess);
          }
        },
        () => {
          toast.error('Data loading error');
        }
      )

    }
	}),
}



export default bank